import React from "react";
import Tooltip from "Components/tooltip/Tooltip";
import { Icon, refresh } from "Icons/index";
import cx from "classnames";
import s from "./domainStatusBadge.scss";

import { capitalize } from "Utils/strings";
import { t } from "i18next";

export default class DomainStatusBadge extends React.Component {
  renderIcon() {
    const { status, archive, isHealthy } = this.props;
    if (
      status === "updating" ||
      status === "validating" ||
      status === "enqueued" ||
      (status === "activating" && archive) ||
      (status === "deleting" && archive) ||
      status === "deleting" ||
      status === "running" ||
      status === "testing" ||
      status === "to_schedule"
    ) {
      return (
        <Icon
          className={s.syncIcon}
          svg={refresh}
          width={this.props.showAsPreview ? "0.4rem" : "0.75rem"}
          height={this.props.showAsPreview ? "0.4rem" : "0.75rem"}
        />
      );
    }

    if (
      (status === "enabled" && !isHealthy && !archive) ||
      status === "completed_with_errors" ||
      status === "valid_with_skipped"
    )
      return <div className={s.warningIcon} />; //<WarningIcon size={20} className={s.warningIcon} />
  }

  shouldComponentUpdate({ status, statusDetail, isHealthy }) {
    if (
      this.props.status === status &&
      this.props.isHealthy === isHealthy &&
      this.props.statusDetail === statusDetail
    ) {
      return false;
    }
    return true;
  }

  generateStatusString() {
    const { status, statusDetail, isHealthy, archive, qbmove } = this.props;

    if (qbmove) {
      if (status === "error") {
        return "Errori";
      }
      if (status === "success") {
        return "Completata";
      }

      if (status === "crashed") {
        return "Il processo è crashato";
      }

      if (status === "running") {
        return "In esecuzione";
      }
    }

    if (status === "ownership_check") {
      return t("status.waitingOwnership");
    }

    if (status === "valid_with_skipped") {
      return t("status.validWithSkipped");
    }

    if (status === "failure") {
      return t("status.failure");
    }

    if (status === "error") {
      return t("status.failure");
    }

    if (status === "enabled" && !isHealthy) {
      return t("status.unhealthy");
    }

    if (status === "enabled" && statusDetail === "wait_pay") {
      return t("status.waitingPayment");
    }

    if (status === "updating" && statusDetail === "disabling") {
      return t("status.disabling");
    }

    if (status === "updating" && statusDetail === "enabling") {
      return t("status.disabling");
    }

    if (status === "disabled" && statusDetail === "wait_delete") {
      return t("status.scheduledDeleting");
    }

    if (status === "disabled" && statusDetail === "expired") {
      return t("status.expired");
    }

    if (status === "disabled" && statusDetail === "vetting") {
      return t("status.disabledByVetting");
    }

    if (status === "disabled" && statusDetail === "admin") {
      return t("status.disabledByAdmin");
    }

    if (status === "disabled" && statusDetail === "customer") {
      return t("status.disabledByCustomer");
    }

    if (status === "disabled" && statusDetail === "manager") {
      return t("status.disabledByManager");
    }

    if (status === "waiting" && statusDetail === "confirmation") {
      return t("status.waitingConfirmation");
    }

    if (status === "updating" && (statusDetail === "deleting" || statusDetail === "deletion")) {
      return t("status.deleting");
    }

    if (status === "updating" && statusDetail === "activating" && archive) {
      return t("status.archiveActivating");
    }

    if (status === "disabled") {
      return t("status.disabled");
    }

    if (status === "updating" || status === "to_schedule") {
      return t("status.updating");
    }

    if (status === "validating") {
      return t("status.validating");
    }

    if (status === "invalid") {
      return t("status.migrationInvalid");
    }

    if (status === "failed" || statusDetail === "invalid resources") {
      return t("status.invalidResources");
    }

    if (status === "validating resources") {
      return t("status.validatingResources");
    }

    if (status === "completed_with_errors") {
      return t("status.completedWithErrors");
    }

    return capitalize(status);
  }

  render() {
    let { status, statusDetail, showAsPreview, archive } = this.props;

    if (status) {
      status = status.replace(" ", "_");
    }

    return (
      <div className={s.wrapBadge}>
        <Tooltip text={this.generateStatusString()}>
          <div
            className={cx(s.badge, {
              [s[status]]: true,
              [s[statusDetail]]: true,
              [s.preview]: showAsPreview,
              [s.archive]: archive,
            })}
          >
            {this.renderIcon()}
          </div>
        </Tooltip>
      </div>
    );
  }
}
